import React from 'react';
import { Link, useMatch } from "../../../vendor/router-ROUTER_TARGET";
import { useSelector } from "react-redux";
import { Root, Trigger } from "@radix-ui/react-context-menu";

import IconCart from './svg/IconCart';
import CartCounter from './CartCounter';
import More from '../common/More';

import useCartMenu from './hooks/useCartMenu';

import './Cart.css';

function CartMenu() {
  const storeRoute = useSelector(state => state.storeRoute)
  const isConnected = useSelector(state => state.isConnected)
  const storePopup = useSelector(state => state.storePopup)
  let match = useMatch({ path: '/cart', end: false });
  const setHistory = () => {
    if (isConnected) {
      storeRoute.goTo('/cart');
    } else {
      storePopup.cart();
    }
  }

  const refresh = useSelector(state => state.cartCounter)
  const { availableDrop, opacity, refDrop, showContextMenu, ContextMenuContent } = useCartMenu(refresh);

  // V1
  const onRightClick = (e) => {
    const el = document.getElementById(`more-ref-cart`);
    (el) && el.click();
  }

  return (
    <Root modal={false}>
      <Trigger>
        <div className={`menu-left-container ${match && `selected`} allow-menu`} onContextMenu={onRightClick}>
          {isConnected ? (
            <Link id={`link-ref-cart`} onClick={setHistory} style={{textDecoration: `none`}} to={isConnected ? '/cart' : '/'}>
              <div id={`ref-cart`} 
                className={`flexRow align top-menu-container cart ${match && `selected`} ${availableDrop && `droppable`}`} 
                ref={refDrop}
                style={{opacity, cursor: (availableDrop) ? `copy` : `pointer`}}
              >
                <IconCart color={'#8C8C8C'} size={28} />
                <div className={'flexRow space-between cart-menu-block'}>
                  <span className={`type-regular fz14`} style={{marginLeft: 1}}>Cart</span>
                  <CartCounter counter={refresh} />
                </div>
              </div>
            </Link>
          ) : (
            <div id={`ref-cart`} 
                className={`flexRow align top-menu-container cart ${match && `selected`} ${availableDrop && `droppable`}`} 
                ref={refDrop}
                style={{opacity, cursor: (availableDrop) ? `copy` : `pointer`}}
                onClick={setHistory}
              >
                <IconCart color={'#8C8C8C'} size={28} />
                <div className={'flexRow space-between cart-menu-block'}>
                  <span className={`type-regular fz14`} style={{marginLeft: 1}}>Cart</span>
                  <CartCounter counter={refresh} />
                </div>
              </div>
          )}
        { isConnected && <More id={`more-ref-cart`} size={24} className={`playlist-more top-menu-section`} onClick={showContextMenu} /> }
        </div>
      </Trigger>
      <ContextMenuContent />
    </Root>
  )
}

export default CartMenu;
